import actions from './actions'

export default function DraftInventorysReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_DRAFTINVENTORY:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_DRAFTINVENTORY:
      console.log('EDIT_DRAFTINVENTORY', action)
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
        openModal: action.openModal,
      }
    case actions.RESET_DRAFTINVENTORY:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
        openModal: null,
      }
    case actions.NEW_DRAFTINVENTORY:
      return {
        ...state,
        editing: { draftInventoryID: 0 },
        loading: false,
        saveSuccess: false,
        openModal: true,
      }
    // Saving keeps the open draft in "editing": a rejected save must leave the dialog
    // open with the same draft (REQUESTING would clear it and the retry would create a new one).
    case actions.SAVING_DRAFTINVENTORY:
      return {
        ...state,
        loading: true,
        saveSuccess: false,
      }
    case actions.SAVE_DRAFTINVENTORY_RECIEVED:
      return action.ok
        ? { ...state, editing: null, loading: false, saveSuccess: true }
        : { ...state, loading: false, saveSuccess: false }
    // Was "case CREATE || UPDATE || DELETE": the first two constants do not exist, so the
    // expression was just DELETE and a save result was never handled (dialog kept spinning).
    case actions.DELETE_DRAFTINVENTORY_RECIEVED:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: true,
      }
    case actions.TRANSFERTOINVENTORY_RECIEVED:
      return {
        ...state,
        loading: false,
        saveSuccess: true,
        openModal: false,
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
